import { isArray } from "lodash";

function updateURLSearchParams(urlSearchParams: URLSearchParams, paramsToUpdate: {
    [name: string]: string | number | undefined | Array<string | number>
}) {
    Object.entries(paramsToUpdate).forEach(([key, value]) => {
        if (isArray(value) && value?.length > 0) {
            urlSearchParams.delete(key);

            value.forEach((item: string) => {
                urlSearchParams.append(key, item);
            });
        } else if (value || value === 0) {
            urlSearchParams.set(key, `${value}`);
        } else {
            urlSearchParams.delete(key);
        }
    });

    return urlSearchParams;
}

export default updateURLSearchParams;
